<main class="content-area">
  <section class="home-hero">
    <div class="home-hero-content">
      <h1>Angular NGX-PFE</h1>
      <p class="head">
        Angular Page Flow Engine.
      </p>

      <div>
        <p>
          The NGX-PFE provides the possibility to dynamically configure flows and pages.
        </p>

        <div>
          <video controls autoplay loop>
            <source src="./assets/video/ngx-pfe.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      <!-- <div class="home-hero-btn">
        <button routerLink="get-started" class="c-button c-button--secondary c-button--medium">Get Started</button>
        <button routerLink="documentation/pfe" class="c-button c-button--secondary c-button--medium">Live Demo</button>
        <button routerLink="editor" class="c-button c-button--primary c-button--medium">
          Config Editor
        </button>
      </div> -->
    </div>
    <div class="bg-img"></div>
    <br />
  </section>
  <!-- <section class="ndbx-tools">
          <div>
              <h2>Tools for creators | developers and designers</h2>
              <div class="row">
                  <div class="ndbx-tools__card col-md-3 col-xs-12">
                      <h3 class=""> Angular NGX-NDBX</h3>
                      <div class="ndbx-tools__image-holder">
                            <img class="ndbx-tools__image" alt="Allianz logo" src="assets/logos/AZ_Logo_positive_RGB.png">
                      </div>
                      <h4>All brand topics</h4>
                      <p>
                          <a class="doc-link" href="https://ngx-ndbx.frameworks.allianz.io/" target="_blank" title="Creators"> Creators</a> the place to create the new Allianz Digital Brand Experience
                      </p>
                  </div>

                  <div class="ndbx-tools__card col-md-3 col-xs-12">
                      <h3>Pattern Lab</h3>
                      <div class="ndbx-tools__image-holder">
                          <img class="ndbx-tools__image" alt="UX guidelines" src="assets/logos/patternlab.png">
                      </div>
                      <h4>Living styleguide</h4>
                      <p>
                          <a class="doc-link" href="https://github.developer.allianz.io/oneMarketing/pattern-lab/" target="_blank" title="PatternLab - Living Styleguide">Living styleguide</a> implementing the B2C components in HTML and CSS
                      </p>
                  </div>

                  <div class="ndbx-tools__card col-md-3 col-xs-12">
                      <h3 class="">Sketch</h3>
                      <div class="ndbx-tools__image-holder">
                          <img class="ndbx-tools__image" alt="Sketch logo" src="assets/logos/sketch.png">
                      </div>
                      <h4>Create designs</h4>
                      <p>
                          Sketch template with ready-to-use B2C components <br> (work in progress)
                      </p>
                  </div>

                  <div class="ndbx-tools__card col-md-3 col-xs-12">
                      <h3>Angular</h3>
                      <div class="ndbx-tools__image-holder">
                          <img class="ndbx-tools__image" alt="Angular logo" src="assets/logos/angular.svg">
                      </div>
                      <h4> Create Angular applications</h4>
                      <p>
                          <a class="doc-link" href="documentation" target="_blank" title="Angular NDBX components">Angular NDBX </a> UI components to enable building Allianz B2C branded Angular applications
                      </p>
                  </div>
              </div>
          </div>
      </section> -->
</main>
